<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>绑定分组课件修复</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col span="6">
            <Form-item label="学生ID">
              <Input v-model="uid" placeholder="空则扫全部 stars>1 学生"></Input>
            </Form-item>
          </Col>
          <Col span="12" style="padding-top: 4px;">
            <Button type="primary" :loading="scanLoading" icon="search" @click="scan(false)">检查</Button>
            <Button type="error" :loading="fixLoading" :disabled="!canFix" style="margin-left: 8px;" @click="confirmFix">一键修复</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <p style="margin: 8px 0 12px;">
      只处理 stars&gt;1 的多级别学生。检查只看不改；修复会改未来已选课件。
      学生 {{ result.studentCount || 0 }}，错课 {{ result.wrongCount || 0 }}，已修 {{ result.fixedCount || 0 }}，
      近5分钟跳过 {{ result.skippedNearCount || 0 }}，陪练组跳过 {{ result.skippedPartnerGroups || 0 }}
    </p>
    <Table border :columns="columns" :data="rows"></Table>
  </div>
</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
export default {
  data () {
    return {
      rankScoreSeq: 0,
      uid: '',
      scanLoading: false,
      fixLoading: false,
      result: {},
      rows: [],
      columns: [
        {title: '学生ID', key: 'uid', width: 100},
        {title: '课ID', key: 'openedId', width: 100},
        {title: '星期', key: 'week', width: 70},
        {title: '开始时间', key: 'startTime', width: 90},
        {
          title: '老师ID',
          key: 'tchId',
          width: 120,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId,
              score: row.monthRankScore
            })
          }
        },
        {title: '开课时间', key: 'lsnBeginText', width: 160},
        {title: '绑定等级', key: 'bindLevelId', width: 90},
        {title: '当前课件', key: 'oldLessonId', width: 90},
        {title: '应为课件', key: 'newLessonId', width: 90},
        {title: '已修复', key: 'fixedText', width: 80},
        {title: '跳过', key: 'skipReason', width: 100}
      ]
    }
  },
  computed: {
    canFix () {
      return !this.scanLoading && !this.fixLoading && (this.result.wrongCount || 0) > 0
    }
  },
  methods: {
    loadMonthRankScores () {
      const table = this.rows
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

    formatTime (sec) {
      if (!sec) {
        return ''
      }
      let d = new Date(sec * 1000)
      let pad = function (n) {
        return n < 10 ? '0' + n : '' + n
      }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
        ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
    },
    flatten (data) {
      let rows = []
      let students = (data && data.students) || []
      students.forEach(function (s) {
        (s.items || []).forEach(function (it) {
          rows.push({
            uid: it.uid,
            openedId: it.openedId,
            week: it.week,
            startTime: it.startTime,
            tchId: it.tchId,
            lsnBeginText: this.formatTime(it.lsnBeginTime),
            bindLevelId: it.bindLevelId,
            oldLessonId: it.oldLessonId,
            newLessonId: it.newLessonId,
            fixedText: it.fixed ? '是' : '否',
            skipReason: it.skipReason || ''
          })
        }.bind(this))
      }.bind(this))
      return rows
    },
    request (fix) {
      let self = this
      let params = {fix: fix}
      if (self.uid && String(self.uid).trim() !== '') {
        params.uid = String(self.uid).trim()
      }
      return self.$http.get('/user/lesson/scanBindGroupLesson', {params: params})
    },
    scan (fix) {
      let self = this
      if (fix) {
        self.fixLoading = true
      } else {
        self.scanLoading = true
      }
      self.request(fix).then(function (res) {
        self.scanLoading = false
        self.fixLoading = false
        if (!res || res.status !== 'ok') {
          return
        }
        self.result = res.data || {}
        self.rows = self.flatten(self.result)
        self.loadMonthRankScores()
        if (!fix) {
          if ((self.result.wrongCount || 0) === 0) {
            self.$Message.success('未发现需要修复的课件')
          } else {
            self.$Message.success('查出 ' + self.result.wrongCount + ' 节错课，确认后可一键修复')
          }
        } else {
          self.$Message.success('已修复 ' + (self.result.fixedCount || 0) + ' 节')
        }
      }).catch(function () {
        self.scanLoading = false
        self.fixLoading = false
      })
    },
    confirmFix () {
      let self = this
      self.$Modal.confirm({
        title: '确认一键修复',
        content: '将按检查结果改 ' + (self.result.wrongCount || 0) + ' 节未来已选课件，不可撤销。只处理 stars>1 的学生。',
        width: 420,
        okText: '确认修复',
        onOk: function () {
          self.scan(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BindGroupLessonScan.vue?4889d61c